import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import {
  BackButton,
  Button,
  Content,
  Input,
  InputContainer,
  Label,
  Tab,
  Tabs,
  Textarea,
  Title,
} from "./SubmitARequestPage.styles";

import { toast } from "sonner";
import MainContainer from "../../components/MainContainer";
import { navigateToTop } from "../../utils/utils";

import { ReactComponent as ChevronLeft } from "../../assets/icons/chevronLeft.svg";

import { selectSubmitRequestLoading } from "../../store/slices/user/slice";
import { submitRequest } from "../../store/slices/user/asyncThunk";
import { selectLoggedIn } from "../../store/slices/auth/slice";
import { setSignUpModalOpen } from "../../store/slices/common/slice";

const TABS = [
  {
    key: "scene",
    label: "Scene",
    namePlaceholder: "Enter scene name",
    detailsPlaceholder: "Describe scene in details",
  },
  {
    key: "feature",
    label: "Feature",
    namePlaceholder: "Enter feature name",
    detailsPlaceholder: "Describe feature",
  },
];

const SubmitARequestPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loading = useSelector(selectSubmitRequestLoading);
  const [activeTab, setActiveTab] = useState("scene");
  const [form, setForm] = useState({ name: "", details: "" });
  const loggedIn = useSelector(selectLoggedIn);
  const currentTab = TABS.find((t) => t.key === activeTab);

  const updateField = (field) => (e) =>
    setForm((prev) => ({ ...prev, [field]: e.target.value }));

  const handleSubmit = async () => {
    if (!loggedIn) {
      dispatch(setSignUpModalOpen(true));
      return;
    }

    if (!form.name.trim() || !form.details.trim()) {
      toast.error("Please fill in all fields");
      return;
    }

    try {
      await dispatch(
        submitRequest({
          type: activeTab,
          title: form.name,
          description: form.details,
        }),
      ).unwrap();

      toast.success("Request submitted successfully");
      navigateToTop(navigate, "/");
    } catch (err) {
      toast.error(err?.message || "Something went wrong");
    }
  };

  return (
    <MainContainer>
      <Content>
        <BackButton onClick={() => navigateToTop(navigate, "/")}>
          <ChevronLeft />
          Back
        </BackButton>

        <Title>What would you like to request?</Title>

        <Tabs $activeTab={activeTab}>
          {TABS.map((tab) => (
            <Tab
              key={tab.key}
              $active={activeTab === tab.key}
              onClick={() => setActiveTab(tab.key)}
            >
              {tab.label}
            </Tab>
          ))}
        </Tabs>

        <InputContainer>
          <Label>Name</Label>
          <Input
            value={form.name}
            onChange={updateField("name")}
            placeholder={currentTab.namePlaceholder}
          />
        </InputContainer>

        <InputContainer>
          <Label>Details</Label>
          <Textarea
            value={form.details}
            onChange={updateField("details")}
            placeholder={currentTab.detailsPlaceholder}
          />
        </InputContainer>

        <Button onClick={handleSubmit} disabled={loading}>
          {loading && (
            <l-line-spinner size="16" stroke="1.25" speed="1.5" color="black" />
          )}
          Submit Request
        </Button>
      </Content>
    </MainContainer>
  );
};

export default SubmitARequestPage;
